<template>
  <div class="expanded-content">

    <!-- Loading -->
    <div v-if="carregando" class="expanded-loading">
      <v-progress-circular indeterminate size="18" width="2" color="primary" class="mr-2" />
      <span class="expanded-loading-text">Carregando produtos do pedido...</span>
    </div>

    <!-- Produtos -->
    <template v-else-if="produtos.length">

      <!-- Aviso de confidencialidade -->
      <div class="aviso-confidencial">
        <v-icon size="16" class="mr-2 aviso-confidencial__icon">mdi-printer-off</v-icon>
        <span>Informações confidenciais — <strong>não imprima</strong> nem <strong>compartilhe</strong> este conteúdo.</span>
      </div>

      <!-- ══ Tabela 1: Venda ══════════════════════════ -->
      <div class="subtable-card">
        <div class="subtable-card-header">
          <v-icon size="18" color="white" class="mr-2">mdi-cart-outline</v-icon>
          Detalhes da Venda
        </div>
        <table class="produtos-table">
          <colgroup>
            <col class="col-produto">
            <col class="col-qtd">
            <col class="col-total">
          </colgroup>
          <thead>
          <tr class="produtos-thead-row">
            <th class="produtos-th">Produto</th>
            <th class="produtos-th text-center">Quantidade</th>
            <th class="produtos-th text-right produtos-th--total">Composição do Total</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(p, pi) in produtos">

            <!-- E-book -->
            <tr
                v-if="p.idproduto === 248545"
                :key="`eb-${pi}`"
                class="ebook-row"
                :style="{ '--combo-cor': comboDoEbook(p.vlrtotal).hex }"
            >
              <td class="ebook-td ebook-td--produto">
                <div class="ebook-nome-wrap">
                  <div class="ebook-icon-wrap">
                    <v-icon size="14" color="white">mdi-book-open-variant</v-icon>
                  </div>
                  <div>
                    <span class="ebook-nome">{{ p.produto }}</span>
                    <span class="ebook-combo-label">{{ comboDoEbook(p.vlrtotal).nome }}</span>
                  </div>
                </div>
              </td>
              <td class="ebook-td text-center">
                <span class="ebook-qtd">{{ p.quantidade }}</span>
              </td>
              <td class="ebook-td produtos-td--total">
                <div class="total-cell">
                  <span v-if="p.vlrtotalbruto !== p.vlrtotal" class="total-bruto">{{ p.vlrtotalbruto | formataDinheiro }}</span>
                  <div v-if="p.desconto" class="total-desc-row total-desc-row--loja">
                      <span class="total-desc-row__label">
                        <v-icon size="9" color="#94a3b8" style="margin-right:2px;">mdi-tag-outline</v-icon>
                        Desconto Comercial
                      </span>
                    <span class="total-desc-row__valor">−{{ p.desconto | formataDinheiro }}</span>
                  </div>
                  <div v-if="p.descontoebook" class="total-desc-row total-desc-row--ebook">
                      <span class="total-desc-row__label">
                        <v-icon size="9" color="#0a7a8a" style="margin-right:2px;">mdi-book-outline</v-icon>
                        Benefício E-book<template v-if="p.percdescontoebook"> ({{ Number(p.percdescontoebook).toFixed(2) }}%)</template>
                      </span>
                    <span class="total-desc-row__valor">−{{ p.descontoebook | formataDinheiro }}</span>
                  </div>
                  <div v-if="p.desconto || p.descontoebook" class="total-divider"></div>
                  <div class="total-cell__liquido">
                      <span class="brinde-badge">
                        <v-icon size="10" color="white" style="margin-right:3px;">mdi-tag-outline</v-icon>
                        Benefício Incluso
                      </span>
                    <span class="ebook-total">{{ p.vlrtotal | formataDinheiro }}</span>
                  </div>
                </div>
              </td>
            </tr>

            <!-- Produto comum -->
            <tr
                v-else
                :key="`pr-${pi}`"
                class="produtos-row"
                :class="{ 'produtos-row--alt': pi % 2 !== 0 }"
            >
              <td class="produtos-td produtos-td--produto" :title="p.produto">
                <span class="produtos-nome">{{ p.produto }} <span class="produto-codigo">Cód.: {{ p.idsubproduto }}</span></span>
              </td>
              <td class="produtos-td text-center">
                <span class="produtos-qtd">{{ p.quantidade }}</span>
              </td>
              <td class="produtos-td produtos-td--total">
                <div class="total-cell">
                  <span v-if="p.vlrtotalbruto !== p.vlrtotal" class="total-bruto">{{ p.vlrtotalbruto | formataDinheiro }}</span>
                  <div v-if="p.desconto" class="total-desc-row total-desc-row--loja">
                      <span class="total-desc-row__label">
                        <v-icon size="9" color="#94a3b8" style="margin-right:2px;">mdi-tag-outline</v-icon>
                        Desconto Comercial
                      </span>
                    <span class="total-desc-row__valor">−{{ p.desconto | formataDinheiro }}</span>
                  </div>
                  <div v-if="p.descontoebook" class="total-desc-row total-desc-row--ebook">
                      <span class="total-desc-row__label">
                        <v-icon size="9" color="#0a7a8a" style="margin-right:2px;">mdi-book-outline</v-icon>
                        Benefício E-book<template v-if="p.percdescontoebook"> ({{ Number(p.percdescontoebook).toFixed(2) }}%)</template>
                      </span>
                    <span class="total-desc-row__valor">−{{ p.descontoebook | formataDinheiro }}</span>
                  </div>
                  <div v-if="p.desconto || p.descontoebook" class="total-divider"></div>
                  <span class="produtos-total">{{ p.vlrtotal | formataDinheiro }}</span>
                </div>
              </td>
            </tr>

          </template>
          </tbody>
          <tfoot>
          <tr class="produtos-tfoot">
            <td colspan="2" class="produtos-td-foot"></td>
            <td class="produtos-td-foot produtos-td--total">
              <div class="foot-total-wrap">
                <span class="foot-total-label">Valor Final do Pedido</span>
                <span class="foot-val foot-val--total">{{ totais.vlrTotal | formataDinheiro }}</span>
              </div>
            </td>
          </tr>
          </tfoot>
        </table>
      </div>

      <!-- ══ Tabela 2: Devolução ══════════════════════════ -->
      <template v-if="temDevolucao">
        <div class="subtable-card subtable-card--dev">
          <div class="subtable-card-header subtable-card-header--dev">
            <v-icon size="18" color="white" class="mr-2">mdi-swap-horizontal</v-icon>
            Detalhes da Devolução
          </div>
          <table class="produtos-table dev-table">
            <colgroup>
              <col class="col-produto">
              <col class="col-qtd">
              <col class="col-total">
            </colgroup>
            <thead>
            <tr class="produtos-thead-row dev-thead-row">
              <th class="produtos-th dev-th">Produto</th>
              <th class="produtos-th dev-th text-center">Qtd. Devolvida</th>
              <th class="produtos-th dev-th text-right dev-th--reembolso">Crédito de Devolução</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(p, pi) in produtos">
              <tr
                  v-if="p.qtddevolvida || p.valorcreditoavulso"
                  :key="`dev-${pi}`"
                  class="dev-row"
                  :class="{ 'dev-row--ebook': p.idproduto === 248545 }"
                  :style="p.idproduto === 248545 ? { '--combo-cor': comboDoEbook(p.vlrtotal).hex } : {}"
              >
                <td class="dev-td dev-td--produto" :title="p.produto">
                  <template v-if="p.idproduto === 248545">
                    <div class="ebook-nome-wrap">
                      <div class="ebook-icon-wrap">
                        <v-icon size="14" color="white">mdi-book-open-variant</v-icon>
                      </div>
                      <div>
                        <span class="ebook-nome">{{ p.produto }}</span>
                        <span class="ebook-combo-label">{{ comboDoEbook(p.vlrtotal).nome }}</span>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="dev-nome-wrap">
                      <span class="dev-nome">{{ p.produto }} <span class="produto-codigo">Cód.: {{ p.idsubproduto }}</span></span>
                    </div>
                  </template>
                </td>
                <td class="dev-td text-center">
                  <span class="devolvido-qtd">{{ p.qtddevolvida }}</span>
                </td>
                <td class="dev-td dev-td--credito dev-td--reembolso">
                  <div v-if="p.valordevolucaoproduto || p.valorcreditoavulso" class="credito-cell">
                    <span class="credito-principal">{{ (p.valordevolucaoproduto || 0) | formataDinheiro }}</span>
                    <div v-if="p.valorcreditoavulso" class="credito-complemento">
                      <v-icon size="9" color="#0a7a8a" style="margin-right:2px;">mdi-plus-circle-outline</v-icon>
                      Crédito Complementar E-book
                      <span class="credito-complemento__valor">{{ p.valorcreditoavulso | formataDinheiro }}</span>
                    </div>
                    <div v-if="p.valorcreditoavulso" class="credito-sep-tracejado"></div>
                    <div v-if="p.valorcreditoavulso" class="credito-total-item">
                      <span class="credito-total-item__valor">{{ ((p.valordevolucaoproduto || 0) + p.valorcreditoavulso) | formataDinheiro }}</span>
                    </div>
                  </div>
                  <span v-else class="devolvido-vazio">—</span>
                </td>
              </tr>
            </template>
            </tbody>
            <tfoot>
            <tr class="dev-tfoot">
              <td colspan="2" class="dev-td-foot"></td>
              <td class="dev-td-foot dev-td-foot--credito dev-td-foot--reembolso">
                <div v-if="totais.descDevolvido || totais.creditoAvulso" class="foot-dev-stack">
                  <div class="credito-cell">
                    <span v-if="totais.creditoAvulso" class="foot-val foot-val--devolvido-base">{{ totais.descDevolvido | formataDinheiro }}</span>
                    <div v-if="totais.creditoAvulso" class="credito-complemento credito-complemento--foot">
                      <v-icon size="9" color="rgba(127,229,240,0.8)" style="margin-right:2px;">mdi-plus-circle-outline</v-icon>
                      Crédito Complementar E-book
                      <span class="credito-complemento__valor">{{ totais.creditoAvulso | formataDinheiro }}</span>
                    </div>
                    <div :class="['foot-total-geral', { 'foot-total-geral--no-divider': !totais.creditoAvulso }]">
                      <span class="foot-total-label">Total Reembolsado</span>
                      <span class="foot-total-geral__valor">{{ (totais.descDevolvido + (totais.creditoAvulso || 0)) | formataDinheiro }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
      </template>

      <!-- ══ Tabela 3: Impacto na Margem ══════════════════════════ -->
      <template v-if="permissao('wolihub_ver_margem') && produtosComMargem.length">
        <div class="subtable-card subtable-card--margem">
          <div class="subtable-card-header subtable-card-header--margem">
            <v-icon size="18" color="white" class="mr-2">mdi-chart-areaspline</v-icon>
            Impacto do E-book na Margem
          </div>
          <table class="produtos-table margem-table">
            <colgroup>
              <col class="col-produto">
              <col v-if="permissao('wolihub_ver_lucro')" class="col-margem-combo">
              <col class="col-margem-combo">
              <col class="col-margem-delta">
            </colgroup>
            <thead>
            <tr class="margem-grupo-row">
              <th class="margem-grupo-th">Produto</th>
              <th v-if="permissao('wolihub_ver_lucro')" class="margem-grupo-th margem-grupo-th--antes">
                <v-icon size="12" color="rgba(200,220,255,0.80)" style="vertical-align:middle; margin-right:4px;">mdi-cash</v-icon>Lucro
              </th>
              <th class="margem-grupo-th margem-grupo-th--depois">
                <v-icon size="12" color="rgba(200,220,255,0.80)" style="vertical-align:middle; margin-right:4px;">mdi-percent</v-icon>Margem
              </th>
              <th class="margem-grupo-th margem-grupo-th--delta">
                <v-icon size="13" color="rgba(255,255,255,0.75)" style="margin-right:4px; vertical-align:middle;">mdi-chart-line-variant</v-icon>Var. Margem
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(p, pi) in produtosComMargem"
                :key="`mg-${pi}`"
                class="margem-row"
                :class="[
                  { 'margem-row--alt': pi % 2 !== 0 },
                  { 'margem-row--ebook': p.idproduto === 248545 }
                ]"
                :style="p.idproduto === 248545 ? { '--combo-cor': comboDoEbook(p.vlrtotal).hex } : {}"
            >
              <!-- Produto -->
              <td class="margem-td margem-td--produto" :title="p.produto">
                <template v-if="p.idproduto === 248545">
                  <div class="ebook-nome-wrap">
                    <div class="ebook-icon-wrap" style="width:20px; height:20px; border-radius:5px;">
                      <v-icon size="11" color="white">mdi-book-open-variant</v-icon>
                    </div>
                    <span class="ebook-nome" style="font-size:12px;">{{ p.produto }}</span>
                  </div>
                </template>
                <template v-else>
                  <span class="produtos-nome">{{ p.produto }} <span class="produto-codigo">Cód.: {{ p.idsubproduto }}</span></span>
                </template>
              </td>

              <!-- Lucro: antes → depois -->
              <td v-if="permissao('wolihub_ver_lucro')" class="margem-td margem-td--antes">
                <div v-if="p.lucro_atual != null" class="margem-combo-cell">
                  <span class="margem-combo-antes">{{ (p.lucro_original != null ? p.lucro_original : 0) | formataDinheiro }}</span>
                  <v-icon size="13" color="#94a3b8">mdi-arrow-right-thin</v-icon>
                  <span :class="['margem-combo-depois', { 'margem-combo-depois--ebook': p.idproduto === 248545 }]">{{ p.lucro_atual | formataDinheiro }}</span>
                </div>
                <span v-else class="margem-vazio">—</span>
              </td>

              <!-- Margem: antes → depois -->
              <td class="margem-td margem-td--depois">
                <div v-if="p.margem_atual != null" class="margem-combo-cell">
                  <span class="margem-combo-antes">{{ formataMargem(p.margem_original != null ? p.margem_original : 0) }}%</span>
                  <v-icon size="13" color="#94a3b8">mdi-arrow-right-thin</v-icon>
                  <span :class="['margem-combo-depois', { 'margem-combo-depois--ebook': p.idproduto === 248545 }]">{{ formataMargem(p.margem_atual) }}%</span>
                </div>
                <span v-else class="margem-vazio">—</span>
              </td>

              <!-- Delta -->
              <td class="margem-td margem-td--delta">
                  <span v-if="p.lucro_original != null" :class="['margem-delta', deltaClass(p)]">
                    <v-icon size="11" :color="deltaIconColor(p)" style="margin-right:2px; vertical-align:middle;">{{ deltaIcon(p) }}</v-icon>
                    {{ formataDelta(p) }}%
                  </span>
                <span v-else class="margem-vazio">—</span>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr class="margem-tfoot">
              <td class="margem-tfoot-td">
                <span class="margem-tfoot-label">Total</span>
              </td>
              <!-- Lucro: antes → depois -->
              <td v-if="permissao('wolihub_ver_lucro')" class="margem-tfoot-td margem-tfoot-td--antes">
                <div class="margem-combo-cell">
                  <span class="margem-tfoot-val margem-tfoot-combo-antes">{{ totalMargem.lucroAntes | formataDinheiro }}</span>
                  <v-icon size="13" color="rgba(255,255,255,0.30)">mdi-arrow-right-thin</v-icon>
                  <span class="margem-tfoot-val">{{ totalMargem.lucroDepois | formataDinheiro }}</span>
                </div>
              </td>
              <!-- Margem: antes → depois -->
              <td class="margem-tfoot-td margem-tfoot-td--depois">
                <div v-if="totalMargem.margemAntes != null" class="margem-combo-cell">
                  <span class="margem-tfoot-val margem-tfoot-combo-antes">{{ formataMargem(totalMargem.margemAntes) }}%</span>
                  <v-icon size="13" color="rgba(255,255,255,0.30)">mdi-arrow-right-thin</v-icon>
                  <span class="margem-tfoot-val">{{ formataMargem(totalMargem.margemDepois) }}%</span>
                </div>
                <span v-else class="margem-vazio">—</span>
              </td>
              <td class="margem-tfoot-td margem-tfoot-td--delta">
                <template v-if="totalMargem.margemAntes != null && totalMargem.margemDepois != null">
                    <span :class="['margem-delta', totalMargem.margemDepois >= totalMargem.margemAntes ? 'margem-delta--pos' : 'margem-delta--neg']">
                      <v-icon size="11" :color="totalMargem.margemDepois >= totalMargem.margemAntes ? '#16a34a' : '#dc2626'" style="margin-right:2px; vertical-align:middle;">
                        {{ totalMargem.margemDepois >= totalMargem.margemAntes ? 'mdi-trending-up' : 'mdi-trending-down' }}
                      </v-icon>
                      {{ totalMargem.margemDepois >= totalMargem.margemAntes ? '+' : '' }}{{ formataMargem(totalMargem.margemDepois - totalMargem.margemAntes) }}%
                    </span>
                </template>
                <span v-else class="margem-vazio">—</span>
              </td>
            </tr>
            </tfoot>
          </table>
        </div>
      </template>

    </template><!-- fecha v-else-if="produtos.length" -->

    <!-- Vazio -->
    <div v-else class="expanded-empty">
      <v-icon size="18" color="grey lighten-2" class="mr-2">mdi-package-variant-outline</v-icon>
      Nenhum produto encontrado para este pedido.
    </div>

  </div>
</template>

<script>
export default {
  name: 'PedidoProdutosExpandido',

  props: {
    produtos:   { type: Array,   default: () => [] },
    totais:     { type: Object,  default: () => ({}) },
    carregando: { type: Boolean, default: false },
    temDevolucao: { type: Boolean, default: false },
  },

  computed: {
    produtosComMargem() {
      return this.produtos.filter(p => p.lucro_atual != null)
    },

    totalMargem() {
      const lista = this.produtosComMargem
      const lucroAntes  = lista.reduce((s, p) => s + (p.lucro_original != null ? Number(p.lucro_original) : 0), 0)
      const lucroDepois = lista.reduce((s, p) => s + (p.lucro_atual    != null ? Number(p.lucro_atual)    : 0), 0)
      const vlrTotal    = Number(this.totais.vlrTotal) || 0
      return {
        lucroAntes,
        lucroDepois,
        margemAntes:  vlrTotal > 0 ? (lucroAntes  / vlrTotal) * 100 : null,
        margemDepois: vlrTotal > 0 ? (lucroDepois / vlrTotal) * 100 : null,
      }
    },
  },

  methods: {
    formataMargem(v) {
      if (v == null) return '—'
      return Number(v).toFixed(2).replace('.', ',')
    },

    formataDelta(p) {
      if (p.margem_original == null || p.margem_atual == null) return '—'
      const d = p.margem_atual - p.margem_original
      return (d >= 0 ? '+' : '') + d.toFixed(2).replace('.', ',')
    },

    deltaClass(p) {
      if (p.margem_original == null || p.margem_atual == null) return ''
      const d = p.margem_atual - p.margem_original
      return d > 0 ? 'margem-delta--pos' : d < 0 ? 'margem-delta--neg' : 'margem-delta--neutro'
    },

    deltaIcon(p) {
      if (p.margem_original == null || p.margem_atual == null) return 'mdi-minus'
      const d = p.margem_atual - p.margem_original
      return d > 0 ? 'mdi-trending-up' : d < 0 ? 'mdi-trending-down' : 'mdi-minus'
    },

    deltaIconColor(p) {
      if (p.margem_original == null || p.margem_atual == null) return '#94a3b8'
      const d = p.margem_atual - p.margem_original
      return d > 0 ? '#16a34a' : d < 0 ? '#dc2626' : '#94a3b8'
    },

    comboDoEbook(vlrtotal) {
      const combos = [
        { nome: 'BRONZE',   valor: 100, hex: '#8d6e63' },
        { nome: 'PRATA',    valor: 150, hex: '#607d8b' },
        { nome: 'OURO',     valor: 200, hex: '#ff8f00' },
        { nome: 'DIAMANTE', valor: 275, hex: '#00838f' },
      ]
      const v = Math.abs(Number(vlrtotal))
      const exato = combos.find(c => c.valor === v)
      if (exato) return exato
      return combos.reduce((prev, curr) =>
          Math.abs(curr.valor - v) < Math.abs(prev.valor - v) ? curr : prev
      )
    },
  },
}
</script>

<style scoped>
/* ── Linha expandida ──────────────────────────────────────────────────────── */
.expanded-content {
  background: #e6edf1;
  border-top: 2px solid #024059;
  border-bottom: 2px solid #024059;
  padding: 28px 24px;
  display: flex;
  flex-direction: column;
  gap: 28px;
}

/* ── Cards de subtabela ───────────────────────────────────────────────────── */
.subtable-card {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.12), 0 0 0 1px rgba(2,64,89,0.20);
}
.subtable-card--dev {
  box-shadow: 0 1px 4px rgba(0,0,0,0.12), 0 0 0 1px rgba(3,89,112,0.22);
}
.subtable-card-header {
  display: flex;
  align-items: center;
  padding: 9px 14px;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.04em;
  text-transform: u%ercase;
  background: #024059;
}
.subtable-card-header--dev { background: #035970; }

/* ── Loading ──────────────────────────────────────────────────────────────── */
.expanded-loading      { display: flex; align-items: center; padding: 14px 16px; background: #eef4f8; }
.expanded-loading-text { font-size: 13px; color: #5a6a7a; }

/* ── Tabela de produtos ───────────────────────────────────────────────────── */
.produtos-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  background: #fff;
}
.col-produto { width: 55%; min-width: 140px; }
.col-qtd     { width: 10%; }
.col-total   { width: 35%; }
.produto-codigo { font-size: 10px; font-weight: 500; color: #94a3b8; white-space: nowrap; }

/* ── Thead ────────────────────────────────────────────────────────────────── */
.produtos-thead-row { background: #024059; }
.produtos-th {
  padding: 8px 14px !important;
  font-size: 10px;
  font-weight: 700;
  text-transform: u%ercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
  text-align: left;
  color: rgba(255,255,255,0.72) !important;
  border-bottom: 2px solid rgba(0,0,0,0.20) !important;
  background: transparent !important;
  vertical-align: middle;
}
.produtos-th--total { border-left: 1px solid rgba(255,255,255,0.12) !important; color: #fff !important; }

/* ── Linhas de dados ──────────────────────────────────────────────────────── */
.produtos-row { background: #fff; transition: background 0.10s ease; }
.produtos-row:hover { background: #f2f8fc !important; }
.produtos-td {
  padding: 8px 14px !important;
  font-size: 12px;
  color: #3d5166;
  border-bottom: 1px solid #edf3f7;
  vertical-align: middle;
  background: inherit;
}
.produtos-row:last-child .produtos-td { border-bottom: none; }
.produtos-td--produto { overflow: hidden; max-width: 0; }
.produtos-td--total   { border-left: 1px solid #dde8f0; background: #f4f8fb !important; }
.produtos-nome {
  font-weight: 600; color: #1e3a4a; font-size: 12px;
  display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.produtos-qtd {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 24px; height: 22px; padding: 0 6px; border-radius: 5px;
  font-weight: 700; font-size: 12px; color: #1e5c78;
  background: #e0eff6; border: 1px solid #b3d4e6; font-variant-numeric: tabular-nums;
}
.produtos-total { font-weight: 700; color: #023449; font-size: 13px; font-variant-numeric: tabular-nums; text-align: right; }

/* ── Célula de composição de total ───────────────────────────────────────── */
.total-cell { display: flex; flex-direction: column; align-items: stretch; gap: 2px; }
.total-cell__liquido { display: flex; align-items: center; justify-content: space-between; gap: 6px; }
.total-bruto { font-size: 11px; font-weight: 500; color: #94a3b8; font-variant-numeric: tabular-nums; text-decoration: line-through; text-align: right; }
.total-desc-row { display: flex; align-items: center; justify-content: space-between; gap: 6px; font-size: 10px; font-variant-numeric: tabular-nums; white-space: nowrap; }
.total-desc-row--loja  { color: #94a3b8; }
.total-desc-row--ebook { color: #0a7a8a; }
.total-desc-row__label { display: flex; align-items: center; flex-shrink: 0; }
.total-desc-row__valor { font-weight: 700; text-align: right; }
.total-divider { border: none; border-top: 1px dashed #d0dde6; margin: 2px 0; }

/* ── Tfoot ────────────────────────────────────────────────────────────────── */
.produtos-tfoot { background: #013347; }
.produtos-td-foot {
  padding: 6px 14px !important;
  background: transparent !important;
  border-top: 2px solid rgba(0,0,0,0.22);
  vertical-align: middle;
}
.produtos-td-foot.produtos-td--total { border-left: 1px solid rgba(255,255,255,0.10) !important; background: rgba(0,0,0,0.10) !important; }
.foot-val             { display: block; font-size: 12px; font-weight: 700; color: rgba(255,255,255,0.7); font-variant-numeric: tabular-nums; }
.foot-val--devolvido-base { font-size: 10px; font-weight: 600; color: rgba(255,255,255,0.75); font-variant-numeric: tabular-nums; text-align: right; }
.foot-val--total      { font-size: 13px; font-weight: 800; color: #ffffff; }
.foot-total-wrap      { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.foot-total-label     { font-size: 10px; font-weight: 600; color: #ffffff; text-transform: u%ercase; letter-spacing: 0.05em; white-space: nowrap; }

/* ── E-book ───────────────────────────────────────────────────────────────── */
.ebook-row { background: color-mix(in srgb, var(--combo-cor) 7%, #fff) !important; }
.ebook-row:hover { background: color-mix(in srgb, var(--combo-cor) 13%, #fff) !important; }
.ebook-td { padding: 8px 14px !important; border-bottom: 1px solid color-mix(in srgb, var(--combo-cor) 18%, #e8f0f5); vertical-align: middle; background: transparent !important; }
.ebook-td.produtos-td--total { border-left: 1px solid rgba(0,0,0,0.05) !important; background: rgba(0,0,0,0.04) !important; }
.ebook-nome-wrap { display: flex; align-items: center; gap: 9px; }
.ebook-icon-wrap { flex-shrink: 0; width: 26px; height: 26px; border-radius: 7px; background: var(--combo-cor); display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 6px color-mix(in srgb, var(--combo-cor) 40%, transparent); }
.ebook-nome { display: block; font-size: 12px; font-weight: 700; color: var(--combo-cor); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ebook-combo-label { display: block; font-size: 9px; font-weight: 700; color: var(--combo-cor); opacity: 0.65; text-transform: u%ercase; letter-spacing: 0.5px; margin-top: 1px; }
.ebook-qtd { display: inline-flex; align-items: center; justify-content: center; min-width: 24px; height: 22px; padding: 0 6px; border-radius: 5px; font-weight: 700; font-size: 12px; color: var(--combo-cor); background: color-mix(in srgb, var(--combo-cor) 12%, #fff); border: 1px solid color-mix(in srgb, var(--combo-cor) 30%, #fff); font-variant-numeric: tabular-nums; }
.ebook-total { font-size: 13px; font-weight: 800; color: var(--combo-cor); font-variant-numeric: tabular-nums; text-align: right; }
.brinde-badge { display: inline-flex; align-items: center; padding: 2px 8px; border-radius: 10px; background: var(--combo-cor); color: #fff; font-size: 10px; font-weight: 700; letter-spacing: 0.4px; white-space: nowrap; opacity: 0.85; }

/* ── Tabela Devolução ─────────────────────────────────────────────────────── */
.dev-thead-row { background: #035970 !important; }
.dev-th { font-size: 10px; font-weight: 700; color: rgba(255,255,255,0.72) !important; padding: 8px 14px !important; border-bottom: 2px solid rgba(0,0,0,0.20) !important; white-space: nowrap; text-align: left; background: transparent !important; vertical-align: middle; }
.dev-th--reembolso { border-left: 1px solid rgba(255,255,255,0.18) !important; }
.dev-row { background: #fff; transition: background 0.10s ease; }
.dev-row:hover { background: #f2f8fc !important; }
.dev-row--ebook { background: color-mix(in srgb, var(--combo-cor) 6%, #fff) !important; }
.dev-td { padding: 8px 14px !important; font-size: 12px; color: #3d5166; border-bottom: 1px solid #edf3f7; vertical-align: middle; background: inherit; }
.dev-row:last-child .dev-td { border-bottom: none; }
.dev-td--produto { overflow: hidden; max-width: 0; }
.dev-td--credito      { text-align: right; }
.dev-td--reembolso    { border-left: 1px solid #b0dfe5; background: #f0fafa; }
.dev-row--ebook .dev-td--reembolso { background: color-mix(in srgb, var(--combo-cor) 6%, #fff) !important; border-left-color: color-mix(in srgb, var(--combo-cor) 30%, #fff); }
.dev-nome-wrap { display: flex; align-items: center; overflow: hidden; }
.dev-nome { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: #1e3a4a; font-weight: 600; }
.dev-td-foot { padding: 8px 14px !important; border-top: 2px solid rgba(0,0,0,0.18); vertical-align: middle; background: #035970; }
.dev-td-foot--credito { text-align: right; }
.dev-td-foot--reembolso { border-left: 1px solid rgba(255,255,255,0.18) !important; background: #024d5c !important; }

/* ── Crédito de devolução ─────────────────────────────────────────────────── */
.credito-cell { display: flex; flex-direction: column; align-items: flex-end; gap: 2px; }
.credito-principal { font-size: 13px; font-weight: 700; color: #0a7a8a; font-variant-numeric: tabular-nums; }
.credito-complemento { display: flex; align-items: center; gap: 2px; font-size: 10px; font-weight: 500; color: #0a7a8a; opacity: 0.75; font-variant-numeric: tabular-nums; white-space: nowrap; }
.credito-complemento--foot { color: rgba(127,229,240,0.85); opacity: 1; }
.credito-complemento__valor { font-weight: 700; margin-left: 3px; }
.credito-sep-tracejado { width: 100%; height: 0; border-top: 1px dashed rgba(10,122,138,0.4); margin: 3px 0 2px; align-self: stretch; }
.credito-total-item { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
.credito-total-item__valor { font-size: 12px; font-weight: 800; color: #024059; font-variant-numeric: tabular-nums; }
.devolvido-qtd { display: inline-flex; align-items: center; justify-content: center; min-width: 24px; height: 22px; padding: 0 6px; border-radius: 5px; font-weight: 700; font-size: 12px; color: #0a7a8a; background: #e2f5f7; border: 1px solid #b0dfe5; font-variant-numeric: tabular-nums; }
.devolvido-vazio { color: #d4e2ea; font-size: 13px; }
.foot-dev-stack { display: flex; flex-direction: column; gap: 4px; }
.foot-total-geral { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin-top: 4px; padding-top: 4px; border-top: 1px solid rgba(255,255,255,0.2); width: 100%; align-self: stretch; }
.foot-total-geral--no-divider { border-top: none; margin-top: 0; padding-top: 0; }
.foot-total-geral__valor { font-size: 13px; font-weight: 800; color: #fff; font-variant-numeric: tabular-nums; }

/* ── Aviso de confidencialidade ───────────────────────────────────────────── */
.aviso-confidencial {
  display: flex;
  align-items: center;
  padding: 9px 14px;
  background: #fff0f0;
  border: 1px solid #f87171;
  border-left: 4px solid #dc2626;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #7f1d1d;
}
.aviso-confidencial__icon { color: #dc2626; flex-shrink: 0; }
.aviso-confidencial strong { font-weight: 800; color: #b91c1c; }

/* ── Tabela de Margem ─────────────────────────────────────────────────────── */
.subtable-card--margem {
  box-shadow: 0 1px 4px rgba(0,0,0,0.12), 0 0 0 1px rgba(30,58,95,0.30);
}
.subtable-card-header--margem { background: #1e3a5f; }

.margem-table { background: #fff; }
.col-margem-combo { width: 200px; }
.col-margem-delta { width: 110px; }

/* Cabeçalho */
.margem-grupo-row { background: #1e3a5f; }
.margem-grupo-th {
  padding: 8px 14px !important;
  font-size: 10px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.5px;
  color: rgba(255,255,255,0.65) !important;
  text-align: left;
  background: transparent !important;
  border-bottom: 2px solid rgba(0,0,0,0.25) !important;
  vertical-align: middle;
  white-space: nowrap;
}
.margem-grupo-th--antes  { background: rgba(100,140,200,0.22) !important; color: rgba(200,220,255,0.90) !important; border-left: 1px solid rgba(100,140,200,0.45) !important; }
.margem-grupo-th--depois { background: rgba(100,140,200,0.22) !important; color: rgba(200,220,255,0.90) !important; border-left: 1px solid rgba(100,140,200,0.45) !important; }
.margem-grupo-th--delta  { text-align: right; color: rgba(200,220,255,0.90) !important; background: rgba(100,140,200,0.22) !important; border-left: 2px solid rgba(100,140,200,0.45) !important; }

/* Linhas */
.margem-row { background: #fff; transition: background 0.10s ease; }
.margem-row:hover { background: #f2f8fc !important; }
.margem-row--alt { background: #fafcfd; }
.margem-row--alt:hover { background: #f0f6fa !important; }

.margem-td {
  padding: 8px 14px !important;
  font-size: 12px; color: #3d5166;
  border-bottom: 1px solid #edf3f7;
  vertical-align: middle;
  background: inherit;
}
.margem-row:last-child .margem-td { border-bottom: none; }
.margem-td--produto  { overflow: hidden; max-width: 0; }
.margem-td--antes  { border-left: 1px solid #e2e8f0; }
.margem-td--depois { border-left: 1px solid #e2e8f0; }
.margem-td--delta  { background: #f4f6f9 !important; border-left: 2px solid #d0d9e8 !important; text-align: center !important; }

/* Célula combo antes → depois */
.margem-combo-cell {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 4px;
  width: 100%;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.margem-combo-antes {
  font-size: 11px;
  font-weight: 500;
  color: #94a3b8;
  text-align: right;
}
.margem-combo-depois {
  font-size: 12px;
  font-weight: 700;
  color: #2c4a6e;
  text-align: left;
}
.margem-combo-depois--ebook { color: #16a34a; }

.margem-delta { display: inline-flex; align-items: center; font-size: 12px; font-weight: 700; font-variant-numeric: tabular-nums; }
.margem-delta--pos    { color: #16a34a; }
.margem-delta--neg    { color: #dc2626; }
.margem-delta--neutro { color: #94a3b8; }
.margem-vazio         { color: #c8d8e4; font-size: 13px; }

.margem-row--ebook { background: color-mix(in srgb, var(--combo-cor) 6%, #fff) !important; border-top: 1px solid color-mix(in srgb, var(--combo-cor) 45%, #e0e0e0) !important; }
.margem-row--ebook:hover { background: color-mix(in srgb, var(--combo-cor) 12%, #fff) !important; }

.margem-tfoot { background: #162e4d; }
.margem-tfoot-td {
  padding: 7px 14px !important;
  border-top: 2px solid rgba(0,0,0,0.25);
  vertical-align: middle;
  background: transparent !important;
}
.margem-tfoot-td--antes  { background: rgba(100,140,200,0.20) !important; border-left: 1px solid rgba(100,140,200,0.45) !important; }
.margem-tfoot-td--depois { background: rgba(100,140,200,0.20) !important; border-left: 1px solid rgba(100,140,200,0.45) !important; }
.margem-tfoot-td--delta  { background: rgba(255,255,255,0.10) !important; border-left: 2px solid rgba(255,255,255,0.20) !important; text-align: center !important; }
.margem-tfoot-td--delta .margem-delta--pos    { color: #4ade80; text-shadow: 0 0 8px rgba(74,222,128,0.45); }
.margem-tfoot-td--delta .margem-delta--neg    { color: #f87171; text-shadow: 0 0 8px rgba(248,113,113,0.45); }
.margem-tfoot-td--delta .margem-delta--neutro { color: rgba(255,255,255,0.55); }
.margem-tfoot-label { font-size: 10px; font-weight: 700; color: rgba(255,255,255,0.6); text-transform: uppercase; letter-spacing: 0.05em; }
.margem-tfoot-val { font-size: 12px; font-weight: 700; color: rgba(255,255,255,0.90); font-variant-numeric: tabular-nums; }
.margem-tfoot-combo-antes { font-size: 11px; font-weight: 500; color: rgba(255,255,255,0.45); text-align: right; }

/* ── Vazio ────────────────────────────────────────────────────────────────── */
.expanded-empty { display: flex; align-items: center; padding: 16px; font-size: 13px; color: #b0bec5; background: #eef4f8; }
</style>
